
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M32.707 9.267A17.82 17.82 0 0021.172 4.03V2.344h1.718a1.172 1.172 0 000-2.344h-5.78a1.172 1.172 0 000 2.344h1.718V4.03a17.782 17.782 0 00-8.336 2.682L9.379 5.598a2.848 2.848 0 00-2.03-.842c-.767 0-1.487.299-2.03.842L3.628 7.294a2.871 2.871 0 000 4.05l1.12 1.124a17.91 17.91 0 00-2.716 9.528c0 4.809 1.869 9.33 5.262 12.73A17.833 17.833 0 0020 40c4.8 0 9.313-1.873 12.707-5.274a17.904 17.904 0 005.262-12.73c0-4.808-1.87-9.329-5.262-12.73zM5.286 8.95l1.693-1.697a.521.521 0 01.74 0l.85.851a18.313 18.313 0 00-2.433 2.437l-.85-.852a.524.524 0 010-.74zM20 37.656c-8.616 0-15.625-7.025-15.625-15.66 0-8.634 7.01-15.66 15.625-15.66 8.616 0 15.625 7.025 15.625 15.66S28.615 37.656 20 37.656z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M20 8.534c-7.41 0-13.438 6.04-13.438 13.463C6.563 29.42 12.591 35.46 20 35.46c7.41 0 13.438-6.04 13.438-13.463 0-7.424-6.028-13.463-13.438-13.463zm1.172 24.52v-1.37a1.172 1.172 0 00-2.344 0v1.37c-5.184-.548-9.315-4.689-9.86-9.885h1.345a1.172 1.172 0 000-2.344H8.968c.545-5.196 4.676-9.337 9.86-9.885v1.37a1.172 1.172 0 002.344 0v-1.37c5.184.548 9.315 4.689 9.86 9.885h-1.344a1.172 1.172 0 000 2.344h1.344c-.545 5.196-4.676 9.337-9.86 9.885z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M22.89 21.32h-1.652v-4.74a1.172 1.172 0 00-2.344 0v5.912c0 .647.525 1.171 1.172 1.171h2.825a1.172 1.172 0 000-2.343z","fill":"currentColor"}})])
          )
        }
      }
    